var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"support-head"},[_c('div',{staticClass:"support-head__title tamara-english-medium-3"},[_c('svg-icon',{attrs:{"name":"support","width":"20px","height":"20px"}}),_vm._v(" "+_vm._s(_vm.$t('sidebar_support_widget_title'))+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }